import React, { useState, useEffect } from 'react';
import Template1 from './TemplateNew.PNG';
import Template2 from './Template2.png';

const EmailDrawer = ({ isOpen, onClose, onSave, initialData }) => {
  // Initialize form state with initial data or defaults
  const [formData, setFormData] = useState({
    campaignName: '',
    campaignTags: '',
    throttling: 'channel',
    template: '',
    testEmail: null
  });

  // Update form when initial data changes
  useEffect(() => {
    if (initialData?.emailConfig) {
      setFormData(initialData.emailConfig);
      setCampaignName(initialData?.emailConfig?.campaignName?.length > 0 ? initialData?.emailConfig?.campaignName : '');
      setEmail(initialData?.emailConfig?.testEmail?.length > 0 ? initialData?.emailConfig?.testEmail : '');
      setCampaignTags(initialData?.emailConfig?.campaignTags?.length > 0 ? initialData?.emailConfig?.campaignTags : '');
      setThrottling(initialData?.emailConfig?.throttling?.length > 0 ? initialData?.emailConfig?.throttling : 'immediate');
    }
  }, [initialData]);


  const [campaignName, setCampaignName] = useState(initialData?.emailConfig?.campaignName?.length > 0 ? initialData?.emailConfig?.campaignName : '');
  const [email, setEmail] = useState(initialData?.emailConfig?.testEmail?.length > 0 ? initialData?.emailConfig?.testEmail : '');
  const [campaignTags, setCampaignTags] = useState(initialData?.emailConfig?.campaignTags?.length > 0 ? initialData?.emailConfig?.campaignTags : '');
  const [throttling, setThrottling] = useState(initialData?.emailConfig?.throttling?.length > 0 ? initialData?.emailConfig?.throttling : 'immediate');
  const [activeTab, setActiveTab] = useState('message'); // Add this state

  const handleSave = () => {
    // Create an object with all the email configuration data
    const emailData = {
      campaignName: campaignName,
      campaignTags: campaignTags,
      throttling: throttling,
      template: campaignTags, // Assuming this is the selected template
      testEmail: email,
    };

    // Pass the data to the parent component
    onSave(emailData);
  };

  // Reset form when drawer closes
  const handleClose = () => {
    setCampaignName('');
    setEmail('');
    setCampaignTags('');
    setThrottling('immediate');
    setActiveTab('basic');
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity z-40"
        onClick={onClose}
      />
      )}

      {/* Drawer */}
      <div
        className={`fixed inset-y-0 right-0 w-[900px] bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-50 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Header with Tabs */}
        <div className="border-b border-gray-200">
          <div className="flex items-center justify-between px-6 py-4">
            <div className="flex space-x-4">
            <div onClick={() => setActiveTab('message')}
                className={`px-4 py-2 rounded-full text-sm ${
                  activeTab === 'message' 
                    ? 'bg-[var(--brand-primary)] bg-opacity-10 text-[var(--brand-primary)]' 
                    : 'text-gray-400 hover:text-gray-600'
                } cursor-pointer`}>Message</div>
              <div  onClick={() => setActiveTab('basic')}
                className={`px-4 py-2 rounded-full text-sm ${
                  activeTab === 'basic' 
                    ? 'bg-[var(--brand-primary)] bg-opacity-10 text-[var(--brand-primary)]' 
                    : 'text-gray-400 hover:text-gray-600'
                } cursor-pointer`}>
                Basic Info
              </div>
              
              <div onClick={() => setActiveTab('test')}
                className={`px-4 py-2 rounded-full text-sm ${
                  activeTab === 'test' 
                    ? 'bg-[var(--brand-primary)] bg-opacity-10 text-[var(--brand-primary)]' 
                    : 'text-gray-400 hover:text-gray-600'
                } cursor-pointer`}>Test</div>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        {activeTab === 'basic'&& <div className="p-6 space-y-6 h-[calc(100vh-180px)] overflow-y-auto">
          {/* Campaign Name */}
          
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">
              CAMPAIGN NAME
            </label>
            <input
              type="text"
              value={campaignName}
              onChange={(e) => setCampaignName(e.target.value)}
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
              placeholder="Enter campaign name"
            />
          </div>

          {/* Campaign Tags */}
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">
              CAMPAIGN TAGS
            </label>
            <select
              value={campaignTags}
              onChange={(e) => setCampaignTags(e.target.value)}
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
            >
              <option value="" disabled>Select...</option>
              <option value="Goal_SIP_Dream Car" >Goal_SIP_Dream Car</option>
              <option value="Goal_SIP_Kids Education" >Goal_SIP_Kids Education</option>
              <option value="Goal_SIP_Tax Saving" >Goal_SIP_Tax Saving</option>
              <option value="Goal_SIP_Dream Vacation" >Goal_SIP_Dream Vacation</option>
              <option value="Goal_SIP_Dream House" >Goal_SIP_Dream House</option>
              <option value="Goal_SIP_Wealth Creation" >Goal_SIP_Wealth Creation</option>
              <option value="Goal_SIP_Kids Education" >Goal_SIP_Kids Education</option>
            </select>
            <p className="mt-1 text-xs text-gray-500">
              This field is optional. Tags help you analyze campaign results for a group of campaigns that belong to a tag. Journey/Relay tags specified here will be applied to all the campaigns that belong to this journey/relay.
            </p>
          </div>

          {/* Throttling */}
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-3">
              THROTTLING
            </label>
            <div className="space-y-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  value="immediate"
                  checked={throttling === 'immediate'}
                  onChange={(e) => setThrottling(e.target.value)}
                  className="h-4 w-4 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                />
                <span className="ml-2 text-sm">Do not throttle campaigns. Send all messages immediately</span>
              </label>
              
              <label className="flex items-center">
                <input
                  type="radio"
                  value="channel"
                  checked={throttling === 'channel'}
                  onChange={(e) => setThrottling(e.target.value)}
                  className="h-4 w-4 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                />
                <span className="ml-2 text-sm">Throttle campaigns as per channel throttling limits (200,000 messages per minute)</span>
              </label>
              
              <label className="flex items-center">
                <input
                  type="radio"
                  value="custom"
                  checked={throttling === 'custom'}
                  onChange={(e) => setThrottling(e.target.value)}
                  className="h-4 w-4 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                />
                <span className="ml-2 text-sm">Throttle campaigns at</span>
                {throttling === 'custom' && (
                  <input
                    type="number"
                    className="ml-2 w-24 rounded-md border-gray-300 shadow-sm focus:border-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                    placeholder="0"
                  />
                )}
                <span className="ml-2 text-sm">messages per minute</span>
              </label>
            </div>
          </div>
        </div>}
        {activeTab === 'message'&& <div className="p-6 space-y-6 h-[calc(100vh-180px)] overflow-y-auto">
         

          {/* Template Selction */}
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">
              Select Template
            </label>
            <select
              value={campaignTags}
              onChange={(e) => setCampaignTags(e.target.value)}
              className="w-full mb-4 rounded-md border-gray-300 shadow-sm focus:border-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
            >
              <option value="" disabled>Select...</option>
              <option value="Template 1" >EDM with Calculator LP</option>
              <option value="Template 2" >Template 2</option>
              {/* <option value="Template 3" >Template 3</option> */}
              {/* <option value="Template 4" >Template 4</option> */}
            </select>
            {/* <p className="mt-1 text-xs text-gray-500">
              This field is optional. Tags help you analyze campaign results for a group of campaigns that belong to a tag. Journey/Relay tags specified here will be applied to all the campaigns that belong to this journey/relay.
            </p> */}
            {campaignTags?.length>0 && campaignTags !== "Template 1" &&  <img src={Template1} alt="Template" />}
            {campaignTags === "Template 1" && <img src={Template2} alt="Template" />}
          </div>

         
        </div>}
        {activeTab === 'test'&& <div className="p-6 space-y-6 h-[calc(100vh-180px)] overflow-y-auto">
         

          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">
              Enter Email
            </label>
            <div className='flex'>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mr-4 rounded-md border-gray-300 shadow-sm focus:border-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
              placeholder="Enter email"
            />
            <button
            onClick={onSave}
            className="w-[10%] bg-[var(--brand-primary)] text-white rounded-md py-2 hover:bg-[#3ba8bd] transition-colors text-sm font-medium"
          >
            SEND
          </button>
            </div>
          </div>

         
        </div>}

        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t bg-white">
          <button
            onClick={handleSave}
            className="w-full bg-[var(--brand-primary)] text-white rounded-md py-2 hover:bg-[#3ba8bd] transition-colors text-sm font-medium"
          >
            SAVE & CONTINUE
          </button>
        </div>
      </div>
    </>
  );
};

export default EmailDrawer;